(function () {
    'use strict';

    angular
        .module('app.layout')
        .controller('ShellController', ShellController);

    ShellController.$inject = ['$rootScope', '$timeout','$state', 'common', '$scope'];
    /* @ngInject */
    function ShellController($rootScope, $timeout, $state, common, $scope) {
        var vm = this;
        vm.busyMessage = 'Please wait ...';
        vm.isBusy = true;
        $rootScope.showSplash = true;
        vm.hideNav = false;
        vm.opsIncludeVersion = common.opsIncludeVersion;

        activate();

        function activate() {
            common.logger.success(common.config.appTitle + ' loaded!', null);
            common.notifier.subscribe(common.config.events.stateChanged, $scope, setState);
            hideSplash();
        }

        function setState() {
            if ($state.current.name == "eventdisplay.display"
                || $state.current.name == "paymenttemplates.pay"
                || $state.current.name == "paymenttemplates.receipt"
                || $state.current.name == "paymenttemplates.error") {
                vm.hideNav = true;
            }
        }

        function hideSplash() {
            //Force a 1 second delay so we can see the splash.
            $timeout(function () {
                $rootScope.showSplash = false;
            }, 1000);
        }
    }
})();
